module.exports = __webpack_public_path__ + "static/media/goboIcon.be01feb2.png";